"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const useTheme_1 = __importDefault(require("@material-ui/core/styles/useTheme"));
const emoji_mart_1 = require("emoji-mart");
const viewMode_1 = require("../../domain/model/viewMode");
exports.default = react_1.default.memo(EmojiPicker);
const useStyles = makeStyles_1.default((theme) => ({
    "@global": {
        ".emoji-mart": {
            backgroundColor: theme.colors.footer.backgroundColor + " !important",
            border: 0,
            borderRadius: 0
        },
        ".emoji-mart-search": {
            paddingBottom: 6,
            display: props => props.showSearch ? "block" : "none"
        },
        ".emoji-mart-search input": {
            paddingTop: 7,
            backgroundColor: theme.colors.textBox.backgroundColor + " !important",
            color: theme.colors.textBox.textColor + " !important"
        },
        ".emoji-mart-category-label": {
            top: -1
        },
        ".emoji-mart-category-label span": {
            backgroundColor: theme.colors.footer.backgroundColor + " !important",
            opacity: 0.9,
            color: theme.colors.footer.mutedColor + " !important"
        },
        ".emoji-mart-category .emoji-mart-emoji span": {
            cursor: "pointer"
        },
        ".emoji-mart-scroll": {
            height: 215
        }
    }
}));
function EmojiPicker(props) {
    const currentViewMode = react_redux_1.useSelector((state) => state.appState.viewMode);
    const styleProps = {
        showSearch: currentViewMode === viewMode_1.ViewMode.Desktop
    };
    useStyles(styleProps);
    const theme = useTheme_1.default();
    return (react_1.default.createElement(emoji_mart_1.Picker, { title: "Pick your emoji...", theme: theme.palette.mode, color: "#d62c7d", onSelect: onSelectEmoji, autoFocus: styleProps.showSearch, showPreview: false, showSkinTones: false, emojiTooltip: true, emoji: "point_up", emojiSize: 28, perLine: 3, native: true, style: {
            width: "100%"
        } }));
    function onSelectEmoji(emojiData) {
        if ("native" in emojiData) {
            props.onEmojiSelected(emojiData.native);
        }
    }
}
